import React, { Fragment } from "react";
import moment from "moment";
import TwitterIcon from '@mui/icons-material/Twitter';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import TelegramIcon from '@mui/icons-material/Telegram';

const Footer = (props) => {
  return (
    <Fragment>
      

     </Fragment>
  );
};

export default Footer;
